import React from 'react';
import { useTranslation } from 'react-i18next';
import { Tabs, Title } from '../../../components/components';
import IdfaRequestConfigDefault from '../../../components/sdk/IdfaRequestConfigDefault';
import LocationRequestConfigDefault from '../../../components/sdk/LocationRequestConfigDefault';

const Configuration = (props) => {
  const { t } = useTranslation()

  return ( <>
    <Title main={"SDK"} sub={t("publisher.actions.configuration")}  />
    <Tabs active={"locationRequestConfig"}>
      <LocationRequestConfigDefault icon={"configure"} as="locationRequestConfig"/>
      <IdfaRequestConfigDefault icon={"configure"} as="idfaRequestConfig"/>
    </Tabs>
  </> );
}
 
export default Configuration;